import { Box, Icon, Text } from '@chakra-ui/react';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface Props {
  icon: IconName;
  number: string | number;
  desc: string;
  loading: boolean;
}

function Stat({ icon, number, desc, loading }: Props) {
  return (
    <Box flex={1} bg="white" boxShadow="lg" borderRadius="2xl" p={6}>
      <Icon
        as={FontAwesomeIcon}
        icon={['fad', icon]}
        size="3x"
        sx={{ '--fa-secondary-color': 'var(--chakra-colors-purple-500)' }}
      />
      <Text fontSize="3xl" fontWeight="bold" my={2}>
        {loading ? '_' : number}
      </Text>
      <Text>{desc}</Text>
    </Box>
  );
}

export default Stat;
